<template> 
<v-layout column="">
    <v-sheet v-if="!image">
        <v-img v-if="!not_images"
            :aspect-ratio="not_ratio"  
            :src="require(`@/assets/${noImage}`)">  
            <v-layout class="pa-10" fill-height column="" > 
                <v-layout  > 
                    <v-spacer></v-spacer> 
                    <v-btn title="Add image"
                        class="primary"
                        @click="addImage()"
                        icon="" outlined=""> 
                        <v-icon color="white">add</v-icon>
                    </v-btn> 
                </v-layout> 
            </v-layout> 
        </v-img>
    </v-sheet>
    <v-sheet v-else>
        <v-img 
            @dblclick="dialog=true"
            :aspect-ratio="not_ratio"  
            :src="image.link"
            lazy-src="https://picsum.photos/10/6?image=3">
            <v-layout
                slot="placeholder"
                fill-height
                align-center
                justify-center
                ma-0 > 
                <v-progress-circular 
                    indeterminate 
                    color="grey lighten-5">
                </v-progress-circular>
            </v-layout>
            <v-layout ma-0 fill-height column="" > 
                <v-layout class="pa-5" >
                    <v-spacer></v-spacer> 
                    <v-avatar
                        size="35"
                        color="rgba(0, 0, 0, 0.3)"  > 
                         
                    </v-avatar>
                    <v-avatar class="mr-1"
                        size="35"
                        color="rgba(0, 0, 0, 0.3)"  > 
                         <v-btn title="Download image" 
                            icon dark
                            @click="dialog=true">
                            <v-icon>get_app</v-icon>
                        </v-btn>
                    </v-avatar>
                    
                    <v-avatar 
                        size="35"
                        color="rgba(0, 0, 0, 0.3)"  > 
                        <v-btn title="Zoom" dark 
                            @click="dialog=true"
                            icon  >
                            <v-icon >fullscreen</v-icon>
                        </v-btn>
                    </v-avatar>
                    <v-btn v-if="imageControl" title="Add image" 
                        dark 
                        @click="addImage()"
                        icon >
                        <v-icon>add_to_photos</v-icon>
                    </v-btn>
                    <v-btn v-if="imageControl" title="Delete image"
                         
                        @click="deleteImage(index)"
                        icon >
                        <v-icon>delete</v-icon>
                    </v-btn>  
                </v-layout>
                <v-layout
                    fill-height
                    align-center 
                    ma-0 > 
                    <v-btn v-if="hasPrev()" color="rgba(0, 0, 0, 0.3)" dark="" icon="" @click="priv()"><v-icon size="35">chevron_left</v-icon></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="hasNext()"  color="rgba(0, 0, 0, 0.3)" icon="" @click="next()" dark=""><v-icon size="35">chevron_right</v-icon></v-btn>
                </v-layout>
            </v-layout> 
        </v-img>
    </v-sheet>

    <v-sheet
        
        class="mt-2"
        elevation="0" >
        <v-slide-group
            v-model="index"
            class="pa-1"
            center-active
            show-arrows >
            <v-slide-item
                v-for="(img, i) in images" :key="i"  
                v-slot:default="{ active, toggle }" >
                <v-card
                    :color="active ? 'primary' : 'grey lighten-1'"
                    class="mx-2 pa-1" 
                    @click="toggle"
                    >
                    <v-img  
                        width="80"
                        height="50"
                        :src="img.link" 
                        lazy-src="https://picsum.photos/10/6?image=3">
                        <v-layout
                            slot="placeholder"
                            fill-height
                            align-center
                            justify-center
                            ma-0 >
                            <v-progress-circular 
                                indeterminate 
                                color="grey lighten-5">
                            </v-progress-circular>
                        </v-layout>
                    </v-img> 
                </v-card>
            </v-slide-item>
        </v-slide-group>
    </v-sheet>

    <div v-if="false" class="mci">

        <!-- main image -->
        <div>   
            <v-img v-if="!not_images"
                aspect-ratio="1.6" 
                full-width
                :src="require(`@/assets/${noImage}`)"
                >  
                 <v-layout  fill-height column="" > 
                    <v-layout  >
                        <v-spacer></v-spacer> 
                        <v-btn title="Add image"
                            color="rgba(0, 0, 0, 0.3)" 
                            dark 
                            @click="addImage()"
                            icon >
                            <v-icon>add</v-icon>
                        </v-btn> 
                    </v-layout> 
                </v-layout> 
            </v-img>   
            <v-img v-else
                @dblclick="dialog=true"
                aspect-ratio="1.6" 
                full-width
                :src="images[index].link"
                lazy-src="https://picsum.photos/10/6?image=3">
                <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0 > 
                    <v-progress-circular 
                        indeterminate 
                        color="grey lighten-5">
                    </v-progress-circular>
                </v-layout>
                <v-layout ma-0 fill-height column="" > 
                    <v-layout>
                        <v-spacer></v-spacer> 
                        <v-btn title="Download image"
                            color="rgba(0, 0, 0, 0.3)" 
                            dark 
                            @click="dialog=true"
                            icon >
                            <v-icon>get_app</v-icon>
                        </v-btn>
                        <v-btn title="Zoom"
                            color="rgba(0, 0, 0, 0.3)" 
                            dark 
                            @click="dialog=true"
                            icon >
                            <v-icon>fullscreen</v-icon>
                        </v-btn>
                        <v-btn v-if="imageControl" title="Add image"
                            color="rgba(0, 0, 0, 0.3)" 
                            dark 
                            @click="addImage()"
                            icon >
                            <v-icon>add_to_photos</v-icon>
                        </v-btn>
                        <v-btn v-if="imageControl" title="Delete image"
                            dark  color="rgba(0, 0, 0, 0.3)" 
                            @click="deleteImage(index)"
                            icon >
                            <v-icon>delete</v-icon>
                        </v-btn>  
                    </v-layout>
                    <v-layout
                        fill-height
                        align-center 
                        ma-0 > 
                        <v-btn v-if="hasPrev()" color="rgba(0, 0, 0, 0.3)" dark="" icon="" @click="priv()"><v-icon size="35">chevron_left</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="hasNext()"  color="rgba(0, 0, 0, 0.3)" icon="" @click="next()" dark=""><v-icon size="35">chevron_right</v-icon></v-btn>
                    </v-layout>
                </v-layout> 
            </v-img>
           
            <v-divider></v-divider>
        </div>
 
        <div class="mt- mci-control">
            <div  v-for="(img, i) in images" :key="i" class="mci-control-item pa-1">
                <div class="mci-b pa-1">
                    <v-card hover="" class="pa-1" :color="index ===i ?'primary':'background' ">
                        <v-img  
                            width="80"
                            height="50"
                            :src="img"
                            @click="go(i)"
                            lazy-src="https://picsum.photos/10/6?image=3">
                            <v-layout
                                slot="placeholder"
                                fill-height
                                align-center
                                justify-center
                                ma-0 >
                                <v-progress-circular 
                                    indeterminate 
                                    color="grey lighten-5">
                                </v-progress-circular>
                            </v-layout>
                        </v-img> 
                        
                    </v-card>
                     
                </div>
            </div> 
        </div>

        <v-layout row wrap justify-center="" class="ma-2">
            <v-btn color="success" @click="downloadImage(1)"><v-icon>get_app</v-icon> download Images</v-btn>  
        </v-layout>

        <!-- Dialogy -->
        <v-layout row justify-center>
            <v-dialog v-model="dialog" fullscreen   transition="dialog-top-transition">
             
            
            <v-toolbar fixed="" dense="" dark color="rgba(0, 0, 0, 0.3)">

                <v-btn icon dark  title="Exit"  @click="dialog = false">
                    <v-icon>arrow_back</v-icon>
                </v-btn> 
                <v-toolbar-title>Zoom Image</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn title="download the Image" 
                        dark 
                        @click="dialog"
                        icon >
                        <v-icon>get_app</v-icon>
                    </v-btn>
                <v-btn title="Zoom In" 
                        dark 
                        @click="zoomIn()"
                        icon >
                        <v-icon>zoom_in</v-icon>
                    </v-btn>
                <v-btn title="Zoom Out" 
                    @click="zoomOut()"
                    icon >
                    <v-icon>zoom_out</v-icon>
                </v-btn>
                <v-btn title="Exit" 
                    @click="dialog = false"
                    icon >
                    <v-icon>fullscreen_exit</v-icon>
                </v-btn>
            </v-toolbar>
            <v-layout fill-height
                    align-center
                    justify-center 
                    class="black" >
                    <div :style="imageSize"   >
                        <v-img 
                            aspect-ratio="1.6" 
                            full-width
                            :src="images[index]"
                            lazy-src="https://picsum.photos/10/6?image=3">
                            <v-layout
                                slot="placeholder"
                                fill-height
                                align-center
                                justify-center
                                ma-0 > 
                                <v-progress-circular 
                                    indeterminate 
                                    color="grey lighten-5">
                                </v-progress-circular>
                            </v-layout>
                            <v-layout ma-0 fill-height column="" > 
                                <v-layout ma-0>
                                    <v-spacer></v-spacer> 
                                    
                                </v-layout>
                                <v-layout
                                    fill-height
                                    align-center 
                                    ma-0 > 
                                    <v-btn v-if="hasPrev()" color="rgba(0, 0, 0, 0.3)" dark="" icon="" @click="priv()"><v-icon size="35">chevron_left</v-icon></v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn  v-if="hasNext()" color="rgba(0, 0, 0, 0.3)" icon="" @click="next()" dark=""><v-icon size="35">chevron_right</v-icon></v-btn>
                                </v-layout>
                            </v-layout> 
                        </v-img>  
                    </div>
            </v-layout> 
            </v-dialog>
        </v-layout> 
         
    </div>
</v-layout>
</template>

<script> 
let imgDownload = require('images-downloader').images;
 
export default {
    props:['not','not_show','not_images','not_ratio','item','imageControl'],
    data(){
        return{  
            visible:true,
            index:0,
            noImage:'system/no_img.png',
            imageWidth:100,

            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,
           model: null
        } 
    },
    mounted(){ 
      
    },
    computed:{ 
        us(){
            return this.not.us
        },
        loading(){  
            return this.not.loading
        },
        processes(){  
            return this.not.processes
        }, 
        responses(){  
            return this.not.responses
        },  
        imageSize(){ 
            return "width: "+this.imageWidth+"%;"
        },
        images(){ 
            return this.not_images
        },
        image(){ 
            if (!this.images) {
                return null
            }
            return this.images[this.index]
        }
         
    },
    methods:{ 
        downloadImage(index){
            let imgs = this.images
            let dest = 'C:\Users\regis\Downloads'
            imgDownload(imgs,dest)
            .then(results=>{
                console.log(results,'rrrrrr');
                
            }).catch(err=>{
                console.log(err,'eeeee');
                
            }) 
        },

        addImage(){
            this.$emit('addImage')    
        },
        deleteImage(i){
            this.$emit('deleteImage',i)    
        },

        show(){
            this.visible = true
        },
        hide(){
            this.visible = false
        },
        hasNext(){
            return this.index+1 < this.images.length
        },
        hasPrev(){
            return this.index-1 >=0
        },
        next(){
            if (this.hasNext()) {
                this.index+=1
            }
        },
        priv(){
            if (this.hasPrev()) {
                this.index-=1
            }
        },
        
        go(i){
            this.index=i
        }, 
        zoomIn(){
            this.imageWidth +=5
        },
        zoomOut(){
            this.imageWidth -=5
        }


    },
    watch:{
       
    }
    

}
</script>
<style>
    .mci{ 
        width: 100%; 
    }
    .mci-b{
       /* background: rgba(0, 0, 0,0.8); */
         border-width: 15px;
        
         border-color: black;
    }
    .mci-control{
        
        overflow: auto;
        overflow-y: hidden; 
        white-space: nowrap
    }
    .mci-control-item{
        display: inline-block;
    }
    .cm-img-view{
        background: rgba(0, 0, 0,0.8); 
    
    }
    .www{
        width: 100%;
    }
</style>

